import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import { useDeleteBookMutation } from "../../features/api/apiSlice";
import DeleteIcon from "../UI/SvgIcons/DeleteIcon";
import EditIcon from "../UI/SvgIcons/EditIcon";
import RatingIcon from "../UI/SvgIcons/RatingIcon";

const BookItem = ({ book }) => {
  const { id, name, author, thumbnail, price, rating, featured } = book || {};

  const [deleteBook] = useDeleteBookMutation();

  const navigate = useNavigate();

  const ratingIcons = Array.from({ length: rating }).map((_, index) => (
    <RatingIcon key={index} />
  ));

  const handleEdit = () => {
    navigate(`/edit/${id}`);
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure want to delete this book?")) {
      const response = await deleteBook(id);
      if (response.error) {
        toast.error("Book deletion failed!");
        return;
      }
      toast.success("Book deleted successfully");
    }
  };

  return (
    <div className="book-card">
      <img
        className="h-[240px] w-[170px] object-cover"
        src={thumbnail}
        alt={name}
      />
      <div className="flex-1 h-full pr-2 pt-2 flex flex-col">
        <div className="flex items-center justify-between">
          {featured && <span className="lws-badge">featured</span>}
          <div className="text-gray-500 space-x-2">
            <button className="lws-edit" onClick={handleEdit}>
              <EditIcon />
            </button>
            <button className="lws-deleteBook" onClick={handleDelete}>
              <DeleteIcon />
            </button>
          </div>
        </div>

        <div className="space-y-2 mt-4 h-full">
          <h4 className="lws-book-name">{name}</h4>
          <p className="lws-author">{author}</p>
          <div className="lws-stars">{ratingIcons}</div>
          <p className="lws-price">BDT {price}</p>
        </div>
      </div>
    </div>
  );
};

export default BookItem;
